import React, { useEffect, useState } from "react"

import { withBase } from "../config/api"

let visitsRequestPromise = null

const getUniqueVisits = () => {
  if (!visitsRequestPromise) {
    visitsRequestPromise = fetch(
      withBase("/public/visits"),
      { credentials: "include" }
    )
      .then((res) => (res.ok ? res.json() : null))
      .catch(() => null)
  }

  return visitsRequestPromise
}

const UniqueVisitCounter = () => {
  const [uniqueVisits, setUniqueVisits] = useState(null)

  useEffect(() => {
    let cancelled = false

    getUniqueVisits().then((data) => {
      if (!cancelled && typeof data?.uniqueVisits === "number") {
        setUniqueVisits(data.uniqueVisits)
      }
    })

    return () => {
      cancelled = true
    }
  }, [])

  if (uniqueVisits === null) return null

  return (
    <span
      aria-label="Unique visits"
      title="Unique visits"
      style={{
        position: "absolute",
        left: 8,
        bottom: 4,
        zIndex: 1,
        color: "rgba(217,255,228,0.55)",
        fontSize: 10,
        lineHeight: 1,
        pointerEvents: "none"
      }}
    >
      {uniqueVisits.toLocaleString()}
    </span>
  )
}

export default UniqueVisitCounter